<!-- header and search-->
<header class="bg-red-gradient home-header" [class.satellite-home-header]="platformShortCode !== 'ar'">
  @if (platformShortCode !== 'ar') {
    <picture class="satellite-background d-flex overflow-hidden">
      @if (platformShortCode === 's2' || platformShortCode === 'es') {
        <source srcset="{{ 'images/heros/background.webp' | platformasset:true:true }}" type="image/webp" />
        <source srcset="{{ 'images/heros/background.png' | platformasset:true:true }}" type="image/png" />
        <img
          alt=""
          aria-hidden="true"
          style="margin-bottom: -170px"
          src="{{ 'images/heros/background.png' | platformasset: true : true }}" />
      } @else {
        <source srcset="{{ 'images/heros/background.svg' | platformasset:true:true }}" type="image/svg" />
        <img
          alt=""
          aria-hidden="true"
          style="margin-bottom: -150px"
          src="{{ 'images/heros/background.svg' | platformasset: true : true }}" />
      }
    </picture>
  }
  <!-- mobile menu ski rent / ski school -->
  @if (platformShortCode === 'ar') {
    <div class="mobile-header-nav d-flex d-lg-none">
      <div class="container d-flex">
        <a [routerLink]="['/SKIHIREENTRY'] | localize" routerLinkActive="active">
          {{ 'ALPINSKIHIRE.navigation.skihire' | alpitranslate }}
        </a>
        <a [routerLink]="['/SKISCHOOLENTRY'] | localize" routerLinkActive="active">
          {{ 'ALPINSKIHIRE.navigation.skischool' | alpitranslate }}
        </a>
      </div>
    </div>
  }

  <!-- search form -->
  <div class="container px-lg-5">
    <div class="row header-wrapper" [class.satellite-min]="platformShortCode !== 'ar'">
      <div class="hero-left-panel col-12 col-lg-4" [class.satellite-left-panel]="platformShortCode !== 'ar'">
        <div class="h-100 d-md-flex d-lg-flex d-xl-flex">
          <div class="d-block mb-desktop">
            <h1 class="h3 mb-2 mb-lg-3 mb-md-3 mb-xl-3 search-form-text">
              <span>{{ 'ALPINSKIHIRE.start.searchHeadline' | alpitranslate }}</span>
            </h1>
            <!-- <app-search-form> -->
            <app-shop-search
              [deliveryShop]="deliveryShop"
              [isIncludedOnStart]="true"
              (changedLocation)="prefetchLocation($event)"
              (preSetLocation)="prefetchLocation($event)"
              (sentForm)="updateForm($event)"
              (skipToDeliveryShop)="skipToDeliveryShop($event)"
              [implementationPage]="'startPage'"></app-shop-search>
            <!-- </app-search-form> -->
          </div>
        </div>
      </div>
      <!-- Alpy Hero either desktop device or not alpi -->
      @if (!isSmallerThanLargeDevice || platformShortCode !== 'ar') {
        @if (platformShortCode === 'ar') {
          <div
            class="hero-right-panel align-self-lg-end align-self-xl-end mb-lg-5 mb-xl-5 col-12 col-lg-8 pr-md-0 pl-md-5">
            @defer (when platformShortCode === 'ar') {
              <app-hero-slider />
            } @placeholder {
              <div class="bg-triangle-down-wrapper">
                <div class="bg-triangle-down"></div>
                <div class="bg-border-down"></div>
              </div>
            }
          </div>
        } @else {
          @switch (platformShortCode) {
            @case ('es') {
              <picture class="satellite-mascot col-12 col-lg-4 d-flex">
                <source
                  srcset="{{ 'images/heros/mascot.webp' | platformasset:true:true }}"
                  type="image/webp" />
                <source srcset="{{ 'images/heros/mascot.png' | platformasset:true:true }}" type="image/png" />
                <img
                  alt=""
                  aria-hidden="true"
                  class="img-responsive"
                  src="{{ 'images/heros/mascot.png' | platformasset: true : true }}" />
              </picture>
            }
            @case ('s2') {
              <picture class="satellite-mascot col-12 col-lg-4 d-flex">
                <source
                  srcset="{{ 'images/heros/mascot.webp' | platformasset:true:true }}"
                  type="image/webp" />
                <source srcset="{{ 'images/heros/mascot.png' | platformasset:true:true }}" type="image/png" />
                <img
                  alt=""
                  aria-hidden="true"
                  class="img-responsive"
                  src="{{ 'images/heros/mascot.png' | platformasset: true : true }}" />
              </picture>
            }
            @case ('sb') {
              <picture class="satellite-mascot col-12 col-lg-4 d-flex">
                <source
                  srcset="{{ 'images/heros/mascot.webp' | platformasset:true:true }}"
                  type="image/webp" />
                <source srcset="{{ 'images/heros/mascot.png' | platformasset:true:true }}" type="image/png" />
                <img
                  alt=""
                  aria-hidden="true"
                  class="img-responsive"
                  src="{{ 'images/heros/mascot.png' | platformasset: true : true }}" />
              </picture>
            }
            @default {
              <picture class="satellite-mascot col-12 col-lg-4 d-flex">
                <source srcset="{{ 'images/heros/mascot.svg' | platformasset:true:true }}" type="image/svg" />
                <img
                  alt=""
                  aria-hidden="true"
                  class="img-responsive"
                  src="{{ 'images/heros/mascot.svg' | platformasset: true : true }}" />
              </picture>
            }
          }
          <div class="col-12 col-lg-4 px-lg-0 satellite-hero-text-container">
            <h1 [innerHTML]="'ALPINSKIHIRE.heroBenefits.headline' | alpitranslate"></h1>
            <h1
              class="subheadline"
              [innerHTML]="
                'ALPINSKIHIRE.heroBenefits.subheadline' | alpitranslate: { discount: upToDiscount }
              "></h1>
            <div class="description">
              <span
                class="p-1 font-weight-bold text-uppercase"
                [innerHTML]="'ALPINSKIHIRE.heroBenefits.benefitsHeader' | alpitranslate"></span
              ><br />
              <ul class="ml-3 p-1">
                <li
                  [innerHTML]="
                    'ALPINSKIHIRE.heroBenefits.benefitFirst' | alpitranslate: { discount: upToDiscount }
                  "></li>
                <li
                  [innerHTML]="
                    'ALPINSKIHIRE.heroBenefits.benefitSecond' | alpitranslate: { discount: upToDiscount }
                  "></li>
                <li>{{ 'ALPINSKIHIRE.heroBenefits.benefitThird' | alpitranslate }}</li>
                <li>{{ 'ALPINSKIHIRE.heroBenefits.benefitFourth' | alpitranslate }}</li>
                @if (platformShortCode === 'es') {
                  <li>{{ 'ALPINSKIHIRE.heroBenefits.benefitFifth' | alpitranslate }}</li>
                }
              </ul>
            </div>
          </div>
        }
        <!-- complete carousel with hoff and texts-->
        <!-- <app-hero-slider></app-hero-slider> -->
      }
    </div>
  </div>
  @if (!isSmallerThanLargeDevice) {
    <div class="hero-nav-container">
      @if (platformShortCode === 'ar') {
        <app-hero-slider-nav [pageType]="'skiHire'"></app-hero-slider-nav>
      }
    </div>
  }
  <div class="d-lg-none">
    @defer (when discount) {
      @if (discount !== undefined) {
        <app-discountticker
          [triangle]="false"
          [animationType]="'squash'"
          [timestamp]="discount.timestamp"
          (tickerEnded)="clearDiscountTicker()" />
      }
    }
  </div>
</header>
<!-- header and search end -->

<!-- why book with us -->
@defer (when 'ar' === platformShortCode && !isSmallerThanLargeDevice) {
  @if ('ar' === platformShortCode && !isSmallerThanLargeDevice) {
    <app-offers></app-offers>
  }
}
<!-- why book with us end -->

<!-- layout for top towns and countries as well as testimonials -->
@if ('ar' === platformShortCode && isSmallerThanLargeDevice) {
  <div class="d-block d-lg-none" style="min-height: 400px">
    <!-- Asterix slider mobile -->
    <section class="container">
      <h2 class="h3 mx-3 text-danger text-center">
        {{ 'ALPINSKIHIRE.start.advantagesHeadline' | alpitranslate }}
      </h2>
      @defer (on viewport) {
        <app-shop-list-advantages />
      } @placeholder {
        <div data-test="shoplist-advantages-placeholder"></div>
      }
    </section>
  </div>
}
<div class="d-md-block">
  <!-- how to book with us -->
  @if ('ar' === platformShortCode) {
    <section data-test="bookWithUsSection" class="container py-5">
      @defer (on viewport) {
        <app-book-with-us />
      } @placeholder {
        <div data-test="book-with-us-placeholder" class="py-5"></div>
      }
    </section>
  }

  <!-- top towns slider -->
  <div class="d-block py-5">
    @defer (on viewport) {
      <app-top-towns class="d-block py-5" />
    } @placeholder {
      <div class="d-block py-5" data-test="top-towns-placeholder"></div>
    } @loading {
      <div class="d-block py-5"></div>
    }
  </div>

  <!-- top countries slider -->
  @if (['ar', 'sb', 'df', 'du'].includes(platformShortCode)) {
    <div class="d-block py-5">
      @defer (on viewport) {
        <app-top-countries class="d-block py-5" />
      } @placeholder {
        <div class="d-block py-5" data-test="top-countries-placeholder"></div>
      }
    </div>
  }

  <!-- brand logos and testimonials -->
  <div>
    @defer (on viewport) {
      <app-testimonials />
    } @placeholder {
      <div data-test="testimonial-placeholder"></div>
    }
  </div>

  <!-- simplyToSki seo stuff -->
  @if ('s2' === platformShortCode) {
    <section>
      @defer (on viewport; when !this.platformService.getIsBrowser()) {
        <app-simply2ski-seo />
      } @placeholder {
        <div data-test="simplyToSki-placeholder"></div>
      }
    </section>
  }
</div>
<!-- desktop layout for top and testimonials end -->
